import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@global/Api';
import { ECOM_COOKIE_KEY } from '@global/App/constants/constants';
import {
  REQUEST_CART,
  REQUEST_CART_TYPE,
  GET_DISCOUNTS,
  GET_DISCOUNTS_RESPONSE,
} from '@global/requests/checkout';
import { RootState } from '@global/store/store';
import { LOCALE_CODES } from '@global/types/types';
import { getCookieValue } from '@global/utils/cookie';

type GetCartDataResponse = REQUEST_CART_TYPE & GET_DISCOUNTS_RESPONSE;

export const getCartData = createAsyncThunk<
  { response: GetCartDataResponse; language: LOCALE_CODES },
  { language: LOCALE_CODES },
  { rejectValue: string }
>('cart/getCartData', async ({ language }, { rejectWithValue, getState }) => {
  try {
    const { cart } = getState() as RootState;
    const ecomToken = getCookieValue(ECOM_COOKIE_KEY) || null;

    const [cartData, cartDiscounts] = await Promise.all([
      client.query<REQUEST_CART_TYPE>({
        query: REQUEST_CART,
        variables: { uid: cart.cartId, ecomToken: ecomToken },
        fetchPolicy: 'no-cache',
      }),
      client.query<GET_DISCOUNTS_RESPONSE>({
        query: GET_DISCOUNTS,
        variables: { uid: cart.cartId },
        fetchPolicy: 'no-cache',
      }),
    ]);

    return {
      response: {
        ...cartData.data,
        ...cartDiscounts.data,
      },
      language: language,
    };
  } catch (error) {
    return rejectWithValue('SERVER ERROR');
  }
});
